import CarbonIcon from "@ecologi/assets/icons/Plan/carbon.svg";
import PlusIcon from "@ecologi/assets/icons/Plan/plus.svg";
import TreesIcon from "@ecologi/assets/icons/Plan/trees.svg";
import {
  BusinessPlanOptions,
  calculateBusinessPlanTotals,
  getLocationPlans,
  Location,
  projectLocationAddonMapper,
} from "@ecologi/shared";
import styles from "../styles/BusinessPlanSummary.module.scss";

type Props = {
  location: Location | null;
  selectedBusinessPlanAddons: BusinessPlanOptions;
  onClickDisplayLocalProject: () => void;
  numLocalTrees: number;
};

export const BusinessPlanSummary = ({
  location,
  selectedBusinessPlanAddons,
  onClickDisplayLocalProject,
  numLocalTrees,
}: Props) => {
  const { currencySymbol, businessAddonsForLocation } =
    getLocationPlans(location);
  const totals = calculateBusinessPlanTotals(
    businessAddonsForLocation,
    selectedBusinessPlanAddons
  );
  const showAddLocalProject =
    location &&
    Object.keys(projectLocationAddonMapper).includes(location.countryCode) &&
    totals.employees > 0 &&
    numLocalTrees === 0;

  return (
    <div className={styles.summary}>
      <h4 className={styles.summaryHeader}>Your monthly total</h4>
      <div className={styles.summaryTotalEmployees}>
        <h4>Total employees</h4>
        <p>{totals.employees.toLocaleString()}</p>
      </div>
      <div className={styles.summaryTotalPrice}>
        <h4>Monthly total</h4>
        <p data-testid="subscription-monthly-total-string">
          {currencySymbol === "$" ? "US$" : currencySymbol}
          {totals.price.toLocaleString()}
        </p>
      </div>
      <p className={styles.summaryVatMessage}>
        This charge is not VAT applicable as the service is VAT exempt
      </p>
      <h3 className={styles.summarySubHeader}>
        Your business&rsquo; yearly impact
      </h3>
      <div className={styles.summaryImpacts}>
        <div className={styles.summaryImpactTrees}>
          <TreesIcon className={styles.summaryImpactIcon} />
          <div>
            <p
              className={styles.summaryTotalImpact}
              data-testid="trees-funded-subscription-string"
            >
              {totals.treesAnnual} trees funded
            </p>
            <p className={styles.summaryImpactTime}>every year</p>
          </div>
        </div>
        <div className={styles.summaryImpactCarbon}>
          <CarbonIcon className={styles.summaryImpactIcon} />
          <div>
            <p
              className={styles.summaryTotalImpact}
              data-testid="carbon-funded-subscription-string"
            >
              {totals.carbonAnnual} tonnes CO<sub>2</sub>e
            </p>
            <p className={styles.summaryImpactTime}>avoided every year*</p>
          </div>
        </div>
      </div>
      <div className={styles.summaryLocalProjectWrapper}>
        {showAddLocalProject && (
          <div
            onClick={onClickDisplayLocalProject}
            className={styles.summaryLocalProject}
            data-testid="add-local-tree-project"
          >
            <PlusIcon /> Add a local project?
          </div>
        )}
      </div>
    </div>
  );
};
